import React from 'react';

import { parseHtml } from '../helpers';

import { BulletPoint } from '../../types/types';

type Props = {
  points?: BulletPoint[];
};

export const CostPoints: React.FC<Props> = ({ points }) => {
  if (!(points && points.length)) {
    return null;
  }
  return (
    <ul className='feature tick' data-testid='mp-product-cost-points'>
      {points?.map((point, i) => (
        <li key={i}>{parseHtml(point.title)}</li>
      ))}
    </ul>
  );
};
